import React from "react";
import { string } from "prop-types";

import { twMerge } from "tailwind-merge";

const Parallelograms = ({ className }) => {
  return (
    <div
      className={twMerge(
        "h-full overflow-hidden w-20 pointer-events-none",
        className
      )}
    >
      <div className="w-20 h-4 bg-primaryOrange relative -right-4 top-6 mb-10 -rotate-45 -skew-x-45" />
      <div className="w-20 h-4 bg-primaryOrange relative -right-4 top-6 mb-10 -rotate-45 -skew-x-45" />
    </div>
  );
};

Parallelograms.propTypes = {
  className: string,
};

export default Parallelograms;
